import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import Loader from "../../../components/Loader/Loader";
import "../../../components/common/css/new.scss";
import "../../Others/Aboutus/Add/addnew.scss";

const NewsAddEdit = () => {
  const { newsId } = useParams();
  const isAdd = !newsId;

  const statusOptions = [
    { value: 0, label: "Draft" },
    { value: 1, label: "Published" },
  ];

  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState([]);
  const [status, setStatus] = useState(statusOptions[0]);
  const [title, setTitle] = useState("");
  const [brief, setBrief] = useState("");
  const [description, setDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const token = localStorage.getItem("accessToken");

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}admin/category-news`,
          {
            headers: { "x-access-token": token },
          }
        );
        const options = response.data.data.rows.map((d) => ({
          value: d.id,
          label: d.category,
        }));
        setCategories(options);
      } catch (error) {
        Swal.fire({
          title: error.response.data.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    };

    const fetchDataById = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API}admin/news/${newsId}`,
          {
            headers: { "x-access-token": token },
          }
        );
        const data = response.data.data;
        setTitle(data.title);
        // setBrief(data.brief);
        setDescription(data.description);
        setStatus(statusOptions.find((opt) => opt.value === data.status));
        setCategoryId(data.category.map((cat) => cat.id));
        setSelectedFile(data.bannerURL)
        setFilePreview(data.bannerURL);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        Swal.fire({
          title: error.response.data.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    };

    fetchCategories();
    if (!isAdd) fetchDataById();
  }, [isAdd, newsId, token]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 10485760) {
        // 10MB limit
        setErrors({ ...errors, image: "Image size should be less than 10MB" });
      } else {
        setErrors({ ...errors, image: "" });
        setSelectedFile(file);
        setFilePreview(URL.createObjectURL(file));
      }
    } else {
      setErrors({ ...errors, image: "" });
      setSelectedFile(null);
      setFilePreview(null);
    }
  };

  const handleDeleteFile = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this image?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.isConfirmed) {
        setSelectedFile(null);
        setFilePreview(null);
        setErrors({ ...errors, image: "" });
        Swal.fire("Deleted!", "The image has been deleted.", "success");
      }
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!title.trim()) newErrors.title = "Title is required";
    // if (!brief.trim()) newErrors.brief = "Brief is required";
    if (!description.trim()) newErrors.description = "Description is required";
    if (!categoryId.length) newErrors.category = "Category is required";
    if (!status) newErrors.status = "Status is required";
    if (!selectedFile) {
      newErrors.image = "Image is required";
    } else if (selectedFile.size > 10485760) {
      newErrors.image = "Image size should be less than 10MB";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const formData = new FormData();
    formData.append("title", title);
    // formData.append("brief", brief);
    formData.append("description", description);
    formData.append("category", JSON.stringify(categoryId));
    formData.append("bannerType", "image");
    formData.append("status", JSON.stringify(status.value));
    if (selectedFile) formData.append("newBanner", selectedFile);

    const config = {
      method: isAdd ? "post" : "patch",
      url: `${process.env.REACT_APP_API}admin/news${isAdd ? "" : "/" + newsId}`,
      headers: {
        "x-access-token": token,
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    };

    try {
      setLoading(true);
      const response = await axios(config);
      setLoading(false);
      Swal.fire({
        title: response.data.message,
        icon: "success",
        confirmButtonText: "OK",
      });
      navigate("/news");
    } catch (error) {
      setLoading(false);
      Swal.fire({
        title: error.response.data.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <Loader isLoading={loading} />
        <div className="bottom">
          <div>
            <div className="modal-content-title">
              {isAdd ? "Add News" : "Edit News"}
            </div>
            <form onSubmit={handleSubmit} className="faq-form">
              <div className="custome-form-group">
                <label>Title*:</label>
                <input
                  type="text"
                  value={title}
                  onChange={(e) => {
                    setTitle(e.target.value);
                    setErrors({ ...errors, title: "" });
                  }}
                  className="custome-input"
                  style={{ width: "524px" }}
                />
                {errors.title && (
                  <div className="invalid-feedback">{errors.title}</div>
                )}
              </div>
              <div className="custome-form-group"></div>
              <div className="custome-form-group">
                <label>Category*:</label>
                <Select
                  isMulti
                  options={categories}
                  value={categories.filter((cat) =>
                    categoryId.includes(cat.value)
                  )}
                  onChange={(selected) => {
                    setCategoryId(
                      selected ? selected.map((sel) => sel.value) : []
                    );
                    setErrors({ ...errors, category: "" });
                  }}
                  className="sort-by dropdown country-drp"
                />
                {errors.category && (
                  <div className="invalid-feedback">{errors.category}</div>
                )}
              </div>
              <div className="custome-form-group"></div>
              <div className="custome-form-group">
                <label>Status*:</label>
                <Select
                  options={statusOptions}
                  value={status}
                  onChange={(selected) => {
                    setStatus(selected);
                    setErrors({ ...errors, status: "" });
                  }}
                  className="sort-by dropdown country-drp"
                />
                {errors.status && (
                  <div className="invalid-feedback">{errors.status}</div>
                )}
              </div>
              <div className="custome-form-group"></div>
              <div className="custome-form-group">
                <label>Banner Image*:</label>
                <input type="file" onChange={(e) => handleFileChange(e)} />
                {errors.image && (
                  <div className="invalid-feedback">{errors.image}</div>
                )}
              </div>
              {filePreview && (
                <div className="image-preview-container">
                  <div className="image-preview">
                    <img
                      src={filePreview}
                      alt="File Preview"
                      style={{ maxWidth: "200px" }}
                    />
                  </div>
                  <button
                    type="button"
                    className="delete-image"
                    onClick={handleDeleteFile}
                  >
                    Delete Image
                  </button>
                </div>
              )}
              {/* <div className="custome-form-group" style={{ width: "95%" }}>
                <label>Brief*:</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={brief}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setBrief(data);
                    setErrors({
                      ...errors,
                      brief: data.trim() ? "" : "Brief is required",
                    });
                  }}
                  config={{ height: 200 }}
                />
                {errors.brief && (
                  <div className="invalid-feedback">{errors.brief}</div>
                )}
              </div> */}
              <div className="custome-form-group" style={{ width: "95%" }}>
                <label>Description*:</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={description}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setDescription(data);
                    setErrors({
                      ...errors,
                      description: data.trim() ? "" : "Description is required",
                    });
                  }}
                  config={{height:'300px'}}
                />
                {errors.description && (
                  <div className="invalid-feedback">{errors.description}</div>
                )}
              </div>
              <button type="submit" className="approveButton">
                {isAdd ? "Save" : "Update"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsAddEdit;
